/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
    let prevScrollPos = window.pageYOffset;
    let isAtTop = true;
    let ticking = false;

    const headerElement = document.querySelector(".header");
    const headerStickyClass = "header-sticky";

    const headerBottom = headerElement.offsetTop + headerElement.offsetHeight;

    const getTopOffset = () => `-${headerElement.offsetHeight}px`;

    const activateStickyHeader = () => {
        headerElement.style.top = "0";
        body.classList.add(headerStickyClass);
    };

    const resetHeader = () => {
        headerElement.style.top = "0";
        body.classList.remove(headerStickyClass);
        isAtTop = true;
    };

    const onScroll = () => {
        const currentScrollPos = window.scrollY;

        if (prevScrollPos < currentScrollPos) {
            // Scrolling down - slide header out
            headerElement.style.top = getTopOffset();
            isAtTop = false;
        } else {
            // Scrolling up - slide header back in as sticky
            if (!isAtTop || currentScrollPos < headerBottom) {
                activateStickyHeader();
            }
        }

        if (currentScrollPos <= 0) {
            resetHeader();
        }

        prevScrollPos = currentScrollPos;
        ticking = false;
    };

    const onScrollThrottled = () => {
        if (!ticking) {
            requestAnimationFrame(onScroll);
            ticking = true;
        }
    };

    window.addEventListener("scroll", onScrollThrottled);
}
